import { render, staticRenderFns } from "./PopupHelp.vue?vue&type=template&id=0335fec2"
import script from "./PopupHelp.vue?vue&type=script&lang=ts"
export * from "./PopupHelp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports